module.exports = __webpack_public_path__ + "static/media/delivery-ubereats.fddb8579.png";